import { Component } from '@angular/core';
import { StepperQueries } from '../../../../core/store/stepper/stepper.queries';
import { HttpService } from '../../../../core/services/http/http.service';
import { EntityQueries } from '../../../../core/store/entity/entity.queries';
import { switchMap } from 'rxjs/operators';
import { APP_ROUTES } from '../../../../core/constants/enum.const';
import { BasePageComponent } from '../../../../core/components/component-base-page/base-page.component';
import { ConfigQueries } from '../../../../core/store/config/config.queries';
import { OnboardingQueries } from '../../../../core/store/onboarding/onboarding.queries';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OnboardingStateModel } from '../../../../core/store/onboarding/onboarding.state';
import { Observable, of } from 'rxjs';

@Component({
	selector: 'bcb-review-legal',
	templateUrl: './review-legal.component.html',
	styleUrls: ['./review-legal.component.scss'],
})
export class ReviewLegalComponent extends BasePageComponent {
	componentLayoutClassList: string[] = ['col-12'];
	private steps: Record<string, any> = {};

	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}

	onPreviousClick(): void {
		this.formGroup.reset();
		this.formGroup.markAsPristine();
		this.stepperQueries.navigateStep('prev');
	}

	handleOnboardingResponse(data: OnboardingStateModel) {
		super.handleOnboardingResponse(data);
		this.steps = this.entity?.profile?.onboarding?.steps ?? {};
		this.isDisabled = !this.canProceed();
	}

	onAnswerChange(): Observable<any> {
		this.isDisabled = !this.canProceed();
		return of(undefined);
	}

	onStepComplete(): Observable<any> {
		return this.http
			.individualTerms({
				...this.formGroup.value,
				entity_id: this.entity?.id,
			})
			.pipe(
				switchMap(() =>
					this.http.completeOnboarding({
						entity_id: this.entity?.id,
					})
				)
			);
	}

	nextButtonText = (): string => {
		if (this.processing$.value) return 'Processing...';
		else if (this.canSubmit()) return 'Submit Onboarding Application';

		return 'Submit';
	};

	afterStepSaveComplete() {
		if (this.entity.profile?.onboarding?.requestFeedback) {
			this.http.logout().then(() => {
				window.location.href = `/${APP_ROUTES.completedWithFeedback}`;
			});
		} else {
			this.http.logout().then(() => {
				window.location.href = `/${APP_ROUTES.completed}`;
			});
		}
	}

	private requiredStepsComplete(): boolean {
		return Object.keys(this.steps)
			.filter((step) => step !== this.currentStep.key)
			.every((step) => this.steps[step]);
	}

	private canProceed(): boolean {
		this.formGroup.markAllAsTouched();
		return this.requiredStepsComplete() && this.formGroup.valid;
	}
}
